// extracted by mini-css-extract-plugin
module.exports = {"boxContentPicker":"BoxContentPicker_boxContentPicker__2VnsC"};